export default __webpack_public_path__ + "static/media/rounded.ab62ad3c.svg";